export const storageKeys = {
   ACCESS_KEY_OUTLET: 'ACCESS_KEY_OUTLET',
};
